// extracted by mini-css-extract-plugin
export default {"vstack":"vstack_vstack__KQ06O"};